import { type BaseRowData } from '@adv-frontend/data-provider';
import { type ColumnHeaderTemplateProps, type GridSortingState } from '@adv-frontend/grid';
import { type GridRow } from './types';

export function getHeaderCellSortingHandler<BaseRow extends BaseRowData = GridRow>(
    props: ColumnHeaderTemplateProps<BaseRow>
) {
    const { column, table } = props;

    return (direction: 'asc' | 'desc' | false) => {
        table.setSorting((sortingState: GridSortingState) => {
            const newSortingState = sortingState.filter((sort) => {
                if (sort.id === column.id) {
                    return false;
                }

                return sort;
            });

            if (!direction) {
                return [...newSortingState];
            }

            return [{ id: column.id, desc: direction === 'desc' }, ...newSortingState];
        });
    };
}
